import SvgIcon from '@mui/material/SvgIcon'
import React, { useId } from 'react'

import { IconProps } from './types'

const PlotlineRuminationDecreaseIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props
  const clipPathId = useId()

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fill: 'none', fontSize, ...style }} {...rest}>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M3.38904 16.7102L7.38904 20.7102L11.389 16.7102"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.38904 4.13146V20.7102"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8467 4.90164V9.15764C14.8467 9.25364 14.8947 9.30164 14.9907 9.30164H16.1267C17.396 9.30164 18.3293 9.09898 18.9267 8.69364C19.524 8.27764 19.8227 7.66431 19.8227 6.85364C19.8227 5.36031 18.6973 4.61364 16.4467 4.61364C15.9667 4.61364 15.4813 4.65631 14.9907 4.74164C14.8947 4.76298 14.8467 4.81631 14.8467 4.90164ZM14.6547 15.2216C14.5373 15.3496 14.388 15.4136 14.2067 15.4136C14.0253 15.4136 13.8707 15.3496 13.7427 15.2216C13.6253 15.0936 13.5667 14.9443 13.5667 14.7736V4.72564C13.5667 4.45898 13.652 4.22964 13.8227 4.03764C13.9933 3.83498 14.2067 3.71764 14.4627 3.68564C15.092 3.61098 15.7907 3.57364 16.5587 3.57364C18.052 3.57364 19.1773 3.85098 19.9347 4.40564C20.7027 4.94964 21.0867 5.72831 21.0867 6.74164C21.0867 7.55231 20.868 8.22964 20.4307 8.77364C20.004 9.30698 19.3907 9.67498 18.5907 9.87764C18.58 9.87764 18.5747 9.88831 18.5747 9.90964C18.5747 9.92031 18.58 9.92564 18.5907 9.92564C19.0493 10.1923 19.5187 10.8856 19.9987 12.0056L21.1507 14.8056C21.2147 14.9443 21.1987 15.083 21.1027 15.2216C21.0173 15.3496 20.8947 15.4136 20.7347 15.4136C20.532 15.4136 20.3453 15.355 20.1747 15.2376C20.0147 15.1203 19.8973 14.971 19.8227 14.7896L18.7027 12.0376C18.3827 11.2696 18.0787 10.795 17.7907 10.6136C17.5133 10.4216 16.9587 10.3256 16.1267 10.3256H14.9907C14.8947 10.3256 14.8467 10.3683 14.8467 10.4536V14.7736C14.8467 14.9443 14.7827 15.0936 14.6547 15.2216Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
export default PlotlineRuminationDecreaseIcon
